// Los avisos tampoco se cierran al tocar fuera: se cierran con sus botones o con ESC, igual que los modales.
import Swal from 'sweetalert2';

const fire = Swal.fire.bind(Swal);
Swal.fire = (...args) => fire(args[0] && typeof args[0] === 'object'
  ? { allowOutsideClick: false, ...args[0] }
  : { allowOutsideClick: false, title: args[0], html: args[1], icon: args[2] });
